const BaseComponent = require('base/base-component');
const { lazyLoadImg, throttle }= require('helper/lazy');

class Footer extends BaseComponent {
  init () {
    this.$el.find('.find-error a').on('click', () => {
      const location = window.location.href;
      window.open(`http://121.43.68.40/exposure/jiucuo.html?site_code=4508000016&url=${location}`);
    });
    // lazyLoadImg('lazy-img');
    window.addEventListener('scroll', throttle(() => lazyLoadImg('lazy-img'), 100));
  }
}

module.exports = Footer;
